import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import { CheckRounded } from '@mui/icons-material';
import moment from 'moment';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';
import Images from '../../../../Configs/images';
import { clearStorage, getUserData } from '../../../../Utils/storages';
import ConfirmationContext from '../../../../Context/ConfirmationContext';
import ROUTES from '../../../../Configs/routes';

const firstRow = [
  { name: 'Privacy and Policy', path: ROUTES.privacyPolicy() },
  { name: 'Terms Of Service', path: ROUTES.termsConditions() },
  { name: 'Scope Of Work', path: ROUTES.termsConditions() },
];

const secondRow = [
  { name: 'Courier T&C', path: ROUTES.privacyPolicy() },
  { name: 'Service Agreements', path: ROUTES.termsConditions() },
  { name: 'Help', path: ROUTES.helpCenter() },
];

export default function Dev({
  classes, error, message,
}) {
  const navigate = useNavigate();
  const userData = getUserData() || {};

  const { openConfirmation, closeConfirmation } = useContext(ConfirmationContext);
  const { openAlert } = useContext(AlertContext);

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  const logout = () => {
    clearStorage();
    window.location.reload();
    closeConfirmation();
  };

  const handleLogout = () => {
    openConfirmation({
      handleAgree: logout,
      handleClose: () => closeConfirmation(),
      title: 'Signing Out?',
      desc: 'Are you sure want to sign out from account?',
      confirmText: 'Yes, Sign Out',
      direction: 'row',
      minWidth: 500,
      maxWidth: 'md',
      btnTextSize: '14px',
    });
  };

  return (
    <Elements.CourierPageBase navigate={navigate}>
      <Box className={classes.root}>
        <section className={`${classes.linearSection}`}>
          <Container>
            <div className="flex space-between align-items-center">
              <h1>
                <img src={Images.LogoWhite} alt="Oeno Bank" height={36} />
              </h1>
            </div>
            <Box mt={5}>
              <Box display="flex" flexDirection="column" alignItems="center">
                <img src={userData.profile_picture} alt="profile_picture" width={80} height={80} className="circle cover" />
                <Box
                  display="inline-flex"
                  alignItems="center"
                  bgcolor="#FDE0E0"
                  gap={1}
                  py={0.5}
                  px={1}
                  borderRadius="4px"
                  className="primary-green"
                  fontWeight="700"
                  mt={-2}
                >
                  <CheckRounded fontSize="small" />
                  Oeno Courier
                </Box>

                <Box color="#fdfdfd" mt={3} fontWeight="700" fontSize={16}>
                  {userData.front_name}
                  {' '}
                  {userData.back_name}
                </Box>

                <Box display="flex" alignItems="center" gap={1} color="#fdfdfd" mt={1}>
                  {userData.id}
                  <Box className="circle" height={4} width={4} bgcolor="#fdfdfd" />
                  Join Date:
                  {' '}
                  {moment(userData.created_at).format('DD MMM YYYY')}
                </Box>
              </Box>
            </Box>
          </Container>
        </section>

        <Container>
          <Box gap={2} display="flex" justifyContent="space-between" mt={3}>
            {firstRow.map((item) => (
              <Box
                key={item.name}
                flex={1}
                bgcolor="#F5F6F8"
                border="1px solid #E5E5E5"
                py={2}
                borderRadius="8px"
                textAlign="center"
                className="link"
                fontSize={16}
                fontWeight="700"
                color="#2E3C40"
                onClick={() => navigate(item.path)}
              >
                {item.name}
              </Box>
            ))}
          </Box>
          <Box gap={2} display="flex" justifyContent="space-between" mt={3}>
            {secondRow.map((item) => (
              <Box
                key={item.name}
                flex={1}
                bgcolor="#F5F6F8"
                border="1px solid #E5E5E5"
                py={2}
                borderRadius="8px"
                textAlign="center"
                className="link"
                fontSize={16}
                fontWeight="700"
                color="#2E3C40"
                onClick={() => navigate(item.path)}
              >
                {item.name}
              </Box>
            ))}
          </Box>
        </Container>

        <Box position="absolute" bottom={80} left={0}>
          <Container>
            <Box display="flex" alignItems="center" gap={1} className="primary-green weight-600 link" onClick={handleLogout}>
              <img src={Images.IconSignout} alt="signout" />
              Sign out
            </Box>
          </Container>
        </Box>
      </Box>
    </Elements.CourierPageBase>
  );
}
